export default __webpack_public_path__ + "static/media/blog-img231.24dcb715.jpg";